/**
 * The pill text input, in one place.
 *
 * PADDING IS NOT A TASTE CHOICE HERE: it must be at least the border radius.
 *
 * A focused `<input>` on iOS clips its text to the rounded box, and it clips
 * conservatively — to the radius' bounding square rather than the curve. With
 * 16px of padding inside a 20px radius the first glyph lands in that square
 * and loses its left edge: the customer screenshot shows "Address or Telegram
 * ID" with the left leg sliced off the A. Unfocused, the same input renders
 * the glyph whole, which is why this survived review — it is only visible once
 * the keyboard is up.
 *
 * So: px-5 against rounded-[20px]. Changing one without the other brings the
 * clipping back, which is why they live on one line instead of in three files.
 *
 * Only `<input>` needs this. A `<div>` with the same radius paints its text
 * normally, so the rounded panels elsewhere are deliberately left alone.
 */
export const PILL_INPUT =
  'appearance-none rounded-[20px] border-0 bg-white py-2.5 px-5 text-[14px] leading-5 text-ink shadow-card outline-none placeholder:text-muted';
